module.exports = __webpack_public_path__ + "hinted-Montserrat-ExtraLightItalic.2c17aeb047ed34eea5f2.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-ExtraLightItalic.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-ExtraLightItalic.ttf
// module chunks = 1